import createImageUrlBuilder from "@sanity/image-url";
import ProvincesMaroc from "assets/ProvincesMaroc/ProvincesMaroc.json";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import Footer from "SanityComponents/Footer/Footer";
import ThreeGuideButtons from "SanityComponents/GuideDuCredit/ThreeGuideButtons";
import Cards from "SanityComponents/LandingPage/Cards";
import LpPrixImmobilier from "SanityComponents/LandingPage/LpPrixImmobilier";
import ThreeButtons from "SanityComponents/LandingPage/ThreeButtons";
import Question from "SanityComponents/Question/Question";
import formatUrl from "utils/FormatUrl";
import SanityHeadSeo from "../sanity/Components/SanityHeadSeo/SanityHeadSeo";
import EstimationHeader from "../SanityComponents/CreditImmobilierComponents/EstimationHeader";
import Card from "../SanityComponents/GuideDuCredit/GuideCards";
import style from "./style.module.css";
import FAQ from "SanityComponents/FAQ/FAQ";
import MostRecentArticles from "SanityComponents/MostRecentArticles";
import WhatssapComponent from "SanityComponents/WhatssapComponent";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});
function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

export function GuideDuCredit(props: { data: any | null; Articles?: any }) {
  const { t, lang } = useTranslation("LandingPage");

  const { data } = props;

  return (
    <div className={style.header}>
      {data?.content.map((item, key) => {
        if (item._type == "lpheader") {
          return (
            <EstimationHeader
              title={item.titre ? item.titre[lang] : ""}
              subtitle={item.soustitre[lang]}
              overlay={item.overlay_image}
              content={item.content}
              backgroundUrl={urlFor(item.background_image)
                .format("webp")
                .auto("format")
                .fit("clip")
                .auto("format")
                .toString()}
              SearchBarInputButton={
                item.SearchBarInputButton ? item.SearchBarInputButton : null
              }
              t={t}
              lang={lang}
            />
          );
        } else if (item._type == "WhatssapComponent") {
          return (
            <WhatssapComponent
              number={item?.numberPhone ? item.numberPhone : null}
              message={item?.message ? item.message[lang] : null}
            />
          );
        } else if (item._type == "GuideThreeButtons") {
          return (
            <>
              <ThreeGuideButtons
                button1={item.button1 ? item.button1[lang] : ""}
                link_button1={item.link_button1}
                button2={item.button2 ? item.button2[lang] : ""}
                link_button2={item.link_button2}
                button3={item.button3 ? item.button3[lang] : ""}
                link_button3={item.link_button3}
                lang={lang}
              />
            </>
          );
        } else if (item._type == "ThreeButtons") {
          return (
            <>
              <ThreeButtons
                btn1={item.titre_button1 ? item.titre_button1[lang] : ""}
                // link1 = {elem.button_link1[lang]}

                btn2={item.titre_button2[lang]}
                // link2 = {elem.button_link2[lang]}

                btn3={item.titre_button3[lang]}
                // link3 = {elem.button_link3[lang]}
                provinces={ProvincesMaroc}
                t={t}
              />
            </>
          );
        } else if (item._type == "QuestionImmobilier") {
          return (
            <div>
              <Question
                title={item.titre ? item.titre[lang] : ""}
                text={item.text ? item.text[lang] : ""}
                buttonText={item.button_text ? item.button_text[lang] : ""}
                image={urlFor(item.mainImage)
                  .format("webp")
                  .auto("format")
                  .fit("clip")
                  .auto("format")
                  .toString()}
                button_link={item.button_link}
              />
            </div>
          );
        } else if (item._type == "LpPrixImmobilier") {
          return (
            <div className={style.simulez}>
              <LpPrixImmobilier
                title={item.titre ? item.titre[lang] : ""}
                texte={item.texte[lang]}
                buttonText={item.button_text ? item.button_text[lang] : ""}
                button_link={item.button_link}
              />
            </div>
          );
        } else if (item._type == "Faq") {
          return <FAQ data={item} lang={lang} />;
        } else if (item.LandingPageCards) {
          return (
            <>
              {item.LandingPageCards && item.LandingPageCards.length > 0 ? (
                <>
                  <div>
                    {item.LandingPageCards.map((elem, index) => {
                      return (
                        <>
                          {elem && (
                            <Cards
                              titre={elem.titre[lang]}
                              texte={elem.text[lang]}
                              button_text={elem.button_text[lang]}
                              lien1={elem.lien1 ? elem.lien1[lang] : null}
                              href1={elem.href1}
                              lien2={elem.lien2 ? elem.lien2[lang] : null}
                              href2={elem.href2}
                              button_link={elem.button_link}
                              image={
                                elem.mainImage
                                  ? urlFor(elem.mainImage)
                                      .format("webp")
                                      .auto("format")
                                      .fit("clip")
                                      .auto("format")
                                      .toString()
                                  : null
                              }
                              t={t}
                            />
                          )}
                        </>
                      );
                    })}
                  </div>
                </>
              ) : null}
            </>
          );
        } else if (item.GuidCreditPageCards) {
          return (
            <>
              {item.GuidCreditPageCards?.GuidCreditPageCards?.length > 0 && (
                <div
                  className={style.guideCardContainer}
                >
                  <div className={style.guideCardTitle}>
                    {item.GuidCreditPageCards?.titre && (
                      <p className={style.guidetitle}>
                        {item.GuidCreditPageCards?.titre[lang]}
                      </p>
                    )}

                    {/* {item.GuidCreditPageCards?.button && (
                      <p className={style.guidebtn}>
                        <a
                          href={formatUrl(
                            item.GuidCreditPageCards?.buttonLink,
                            lang
                          )}
                        >
                          {item.GuidCreditPageCards?.button[lang]}
                        </a>
                      </p>
                    )} */}
                  </div>

                  <div className={style.postsCardsContainer}>
                    {item.GuidCreditPageCards?.GuidCreditPageCards?.map(
                      (elem, index) => {
                        return (
                          <>
                            {elem && (
                              <a
                                href={formatUrl(
                                  `/guide-du-credit/${elem.slug.current}`,
                                  lang
                                )}
                              >
                                <Card
                                  image={urlFor(elem.mainImage)
                                    .width(404)
                                    .height(187)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()}
                                  title={elem.title ? elem.title[lang] : ""}
                                  subtitle={
                                    elem.subtitle ? elem.subtitle[lang] : ""
                                  }
                                  width={elem.width ? elem.width : 404}
                                  height={elem.height ? elem.height : 187}
                                />
                              </a>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            </>
          );
        }
        // else if (item._type == "MostRecentArticles" && props.Articles.length > 0) {
        //   return (
        //     <MostRecentArticles key={key} title={item.titre[lang]} linkArticles={props.Articles.slice(0,10)} lang={lang} />
        //   )
        // }
        else if (item._type == "SanityHeadSeo") {
          return (
            <SanityHeadSeo
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              ogTitle={item.titre ? item.titre[lang] : ""}
              description={item.description ? item.description[lang] : ""}
              ogDescription={item.description ? item.description[lang] : ""}
              canonicalUrl={item.canonicalUrl}
              ogTwitterImage={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              ogType={item.ogType}
              ogImageUrl={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              structuredData={null}
            >
              <></>
            </SanityHeadSeo>
          );
        } else if (item._type == "SanityFooter") {
          return (
            <>
              <div className={style.footer}>
                <div className={style.footerDesk}>
                  <Footer
                    propos={item.propos[lang]}
                    proposText={item.text ? item.text[lang] : ""}
                    donnee={item.donnees[lang]}
                    donneeText={item.textdonnee[lang]}
                    technologie={item.technologie[lang]}
                    technologieText={item.texttechnologies[lang]}
                    logo={urlFor(item.agenz_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    facebook={urlFor(item.facebook_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    instagram_logo={urlFor(item.instagram_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    linked_in={urlFor(item.linkedin_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    socialMediaText={item.socialMediatext}
                    copyRightText={item.permission_text}
                  />
                </div>
                {/* <div className={style.footerMobile}>
                        <MobileFooter/>
                    </div> */}
              </div>
            </>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}
